import { startCase } from 'lodash'

export const WESPER_BRAND_ID = 14

export enum DeviceStates {
  INTERNAL_USE = 'INTERNAL_USE',
  STOCK = 'STOCK',
  RENEWED_STOCK = 'RENEWED_STOCK',
  CONSIGNED = 'CONSIGNED',
  DISPOSED = 'DISPOSED',
  SOLD = 'SOLD',
  RETURN_IN_TRANSIT = 'RETURN_IN_TRANSIT',
  RETURN_RECEIVED = 'RETURN_RECEIVED',
  IN_REPAIR = 'IN_REPAIR',
  DEFECTIVE = 'DEFECTIVE',
  DAMAGED = 'DAMAGED',
  LOST = 'LOST',
  BILLED = 'BILLED',
  // past its shelf life (TES-3191)
  RETIRED = 'RETIRED',
}

export const statusOptions = Object.keys(DeviceStates).map((s) => ({
  value: s,
  key: startCase(s.replace(/_/g, ' ').toLowerCase()),
}))
